 <div class="col-12">
    <div class="border rounded-2 p-4">
      <h3  class="text-center">CMD Review for Initial Approval</h3>
      <div class="input-group">
        <input type="text" class="form-control" placeholder="Search Kaizen" aria-label="Search Kaizen" #searchCriteria (keydown.enter)="OnSearch(searchCriteria.value)">
        <button  class="btn btn-outline-info fa fa-search" type="button"  (click)="OnSearch(searchCriteria.value)">Search</button>        
      </div><br>
      <div class="boldtext">Total {{totalItems}} Kaizens</div>
<table class="table table-hover" matSort #sort="matSort">
  <thead>
    <tr>
      <th mat-sort-header="kaizenNumber" scope="col">KZ NUM#</th>
      <th mat-sort-header="company" scope="col">NAMC</th>
      <th mat-sort-header="shop" scope="col">Shop</th>
      <th mat-sort-header="name" scope="col" class="wrap">Name</th>
      <th mat-sort-header="account" scope="col">Account</th>
      <th mat-sort-header="fySavings" scope="col">Est FY Savings</th>
      <th mat-sort-header="internalTrackingNo" scope="col">Int Tracking No</th>
      <th mat-sort-header="trackingRef1" scope="col">Tracking Ref 1</th>
      <th mat-sort-header="trackingRef2" scope="col">Tracking Ref 2</th>
      <th mat-sort-header="state" scope="col">Status</th>
      <th scope="col">Action</th>
      <th scope="col">Actuals</th>
    </tr>
  </thead>
    <tbody>
      <tr *ngFor="let kaizen of sortedKaizens">
      <ng-container *ngIf="kaizen.state.toString()=='Submitted'">
        <th scope="row"> K{{kaizen.kaizenNumber}}</th> 
          <td>{{kaizen.company}}</td> 
          <td>{{shopSizer(kaizen.shop.toString())}}</td>
          <td>{{kaizen.name}}</td>
          <td>{{kaizen.account}}</td>
          <td>{{kaizen.fySavings | currency:'USD':'symbol':'1.0'}}</td>
          <td>{{kaizen.internalTrackingNo}}</td>
          <td>{{kaizen.trackingRef1}}</td>
          <td>{{kaizen.trackingRef2}}</td>
          <td>{{kaizen.state}}</td>
          <td><a routerLink="../cmdrkaizendetail/{{kaizen.kaizenId}}" >Review</a></td>
          <td></td>
      </ng-container>
      </tr> 
      <tr *ngFor="let kaizen of sortedKaizens" class="disabledrow">        
        <ng-container *ngIf="kaizen.state.toString() == 'In progress'">
          <th scope="row"> K{{kaizen.kaizenNumber}}</th>            
            <td>  {{kaizen.company}}</td> 
            <td>{{shopSizer(kaizen.shop.toString())}}</td>
            <td>{{kaizen.name}}</td>
            <td>{{kaizen.account}}</td>
            <td>{{kaizen.fySavings | currency:'USD':'symbol':'1.0'}}</td>
            <td>{{kaizen.internalTrackingNo}}</td>
            <td>{{kaizen.trackingRef1}}</td>
            <td>{{kaizen.trackingRef2}}</td>
            <td>  {{kaizen.state}} </td>
            <td><a routerLink="../cmdrkaizendetail/{{kaizen.kaizenId}}" >View Only</a></td>
            <td><a routerLink="../actuals/{{kaizen.kaizenId}}" >Actuals</a></td>
        </ng-container>
        </tr>
        <tr *ngFor="let kaizen of sortedKaizens" class="disabledrow">        
          <ng-container *ngIf="kaizen.state.toString()!=='Draft' && kaizen.state.toString()!=='Submitted' && kaizen.state.toString() !== 'In progress' && kaizen.state.toString() !== 'Cost Confirmed' && kaizen.state.toString()!='Complete'">
            <th scope="row"> K{{kaizen.kaizenNumber}}</th>            
              <td> {{kaizen.company}}</td> 
              <td>{{shopSizer(kaizen.shop.toString())}}</td>
              <td>{{kaizen.name}}</td>
              <td>{{kaizen.account}}</td>
              <td>{{kaizen.fySavings | currency:'USD':'symbol':'1.0'}}</td>
              <td>{{kaizen.internalTrackingNo}}</td>
              <td>{{kaizen.trackingRef1}}</td>
              <td>{{kaizen.trackingRef2}}</td>
              <td> {{kaizen.state}}</td>
              <td><a routerLink="../cmdrkaizendetail/{{kaizen.kaizenId}}" >View Only</a></td>
              <td></td>
          </ng-container>
          </tr>
          <tr *ngFor="let kaizen of sortedKaizens" class="disabledrow">        
            <ng-container *ngIf="kaizen.state.toString()=='Cost Confirmed' || kaizen.state.toString()=='Complete'">
              <th scope="row"> K{{kaizen.kaizenNumber}}</th>            
                <td> {{kaizen.company}}</td> 
                <td>{{shopSizer(kaizen.shop.toString())}}</td>
                <td>{{kaizen.name}}</td>
                <td>{{kaizen.account}}</td>
                <td>{{kaizen.fySavings | currency:'USD':'symbol':'1.0'}}</td>
                <td>{{kaizen.internalTrackingNo}}</td>
                <td>{{kaizen.trackingRef1}}</td>
                <td>{{kaizen.trackingRef2}}</td>
                <td>{{kaizen.state}}</td>
                <td><a routerLink="../cmdrkaizendetail/{{kaizen.kaizenId}}" >View Only</a></td>
                <td><a routerLink="../actuals/{{kaizen.kaizenId}}" >Actuals</a></td>
            </ng-container>
            </tr>          
    </tbody>
  </table>
   <mat-paginator
      [length]="totalItems"
      [pageSize]="pageSize"
      [pageSizeOptions]="[25, 50, 100]"
      showFirstLastButtons
    >
    </mat-paginator>
    </div>
    </div>